import { useState, useEffect } from "react";
import { navLinks } from "../../data/mock";
import { Menu, X, Mail, Phone } from "lucide-react";
import { Button } from "../ui/button";
import { CallbackModal } from "./CallbackModal";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [callbackModalOpen, setCallbackModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl shadow-lg shadow-black/5 border-b border-[#E2E8F0]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex items-center group">
            <img
              src="/assets/colored-logo.png"
              alt="IQ Hub"
              className="h-10 w-auto"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="px-4 py-2 text-sm text-[#475569] hover:text-[#C8A951] transition-colors duration-200 rounded-lg hover:bg-[#C8A951]/5"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden lg:flex items-center gap-3">
            <Button 
              onClick={() => setCallbackModalOpen(true)}
              variant="outline"
              className="border-[#0F172A]/20 text-[#0F172A] hover:bg-[#0F172A]/5 hover:border-[#0F172A]/40 font-semibold text-sm px-5 rounded-lg"
            >
              <Phone className="w-4 h-4 mr-2" />
              Request a Call
            </Button>
            <a href="mailto:support@iq-hub.com">
              <Button className="bg-[#C8A951] hover:bg-[#B8993F] text-[#0F172A] font-semibold text-sm px-5 rounded-lg group">
                <Mail className="w-4 h-4 mr-2" />
                Get in Touch
              </Button>
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden text-[#0F172A] p-2 hover:bg-[#0F172A]/5 rounded-lg transition-colors"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? "max-h-[400px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-white/95 backdrop-blur-xl border-t border-[#E2E8F0] px-6 py-4 shadow-lg">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-[#475569] hover:text-[#C8A951] hover:bg-[#C8A951]/5 rounded-lg transition-colors text-sm"
              >
                {link.label}
              </a>
            ))}
            <div className="mt-3 pt-3 border-t border-[#E2E8F0] space-y-2">
              <Button 
                onClick={() => {
                  setMobileOpen(false);
                  setCallbackModalOpen(true);
                }}
                variant="outline"
                className="border-[#0F172A]/20 text-[#0F172A] hover:bg-[#0F172A]/5 hover:border-[#0F172A]/40 font-semibold w-full"
              >
                <Phone className="w-4 h-4 mr-2" />
                Request a Call
              </Button>
              <a href="mailto:support@iq-hub.com">
                <Button className="bg-[#C8A951] hover:bg-[#B8993F] text-[#0F172A] font-semibold w-full">
                  <Mail className="w-4 h-4 mr-2" />
                  Get in Touch
                </Button>
              </a>
            </div>
          </nav>
        </div>
      </div>
    </header>
    
    {/* Callback Modal */}
    <CallbackModal 
      isOpen={callbackModalOpen} 
      onClose={() => setCallbackModalOpen(false)} 
    />
    </>
  );
};
